<template>
  <v-layout row wrap py-3>
    <v-flex xs12 md12>
      <v-layout row wrap>
        <v-flex xs12 md4 pa-1 v-for="(r, i) in resource.data" :key="'resource-'+i">
          <v-card>
            <v-flex xs12 style="height:2px;">
              <v-progress-linear height="2" class="pa-0 ma-0" v-if="loading" :indeterminate="true"></v-progress-linear>
            </v-flex>
            <v-img
              on="on"
              v-if="r.splash"
              class="elevation-2"
              :src="r.splash"
              height="175px"
            >
            </v-img>
            <v-card-title primary-title class="title">
              {{r.title_en}}
            </v-card-title>
            <v-card-text>
              <v-layout wrap row align-baseline>
                <v-flex xs12>
                  <div>{{r.description_en}}</div>
                </v-flex>
                <v-flex xs6 v-if="staticPages">
                  COUNTRY: {{r.country.name}}
                </v-flex>
                <v-flex xs6 v-if="!staticPages">
                  <v-layout wrap row align-baseline>
                    <v-flex xs12 v-for="(product, p) in r.products_raw" :key="p + '-product'" style="font-size:11px;font-weigh:bold;">
                      {{product.sku}}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-center py-1">
                    <v-chip small>
                      <v-icon left v-if="r.active" color="success" size="15">check_circle</v-icon>
                      <v-icon left v-else color="error" size="15">cancel</v-icon>
                      <span v-if="r.active" style="text-transform:uppercase;font-weight:bold;"> active </span>
                      <span v-else style="text-transform:uppercase;font-weight:bold;"> not active </span>
                    </v-chip>
                  </div>
                  <div class="text-xs-center py-1" v-if="!staticPages">
                    <v-chip small>
                      <v-icon left v-if="r.cart" color="success" size="15">shopping_cart</v-icon>
                      <v-icon left v-else color="error" size="15">shopping_cart</v-icon>
                      <span v-if="r.cart" style="text-transform:uppercase;font-weight:bold;"> cart </span>
                      <span v-else style="text-transform:uppercase;font-weight:bold;"> no cart </span>
                    </v-chip>
                  </div>
                  <div class="text-xs-center py-1" v-if="!staticPages">
                    <v-chip small>
                      <v-icon left v-if="r.online_payment" color="success" size="15">credit_card</v-icon>
                      <v-icon left v-else color="error" size="15">credit_card</v-icon>
                      <span v-if="r.online_payment" style="text-transform:uppercase;font-weight:bold;"> online payment </span>
                      <span v-else style="text-transform:uppercase;font-weight:bold;"> no online payment </span>
                    </v-chip>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="customCheckBoxCopyLink">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-checkbox label="CUSTOMER DATA" v-model="customer" value="true" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox label="LAZY LOAD" v-model="lazy" value="true" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox label="LANGUAGE" v-model="language" value="true" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox label="FREE DELIVERY" v-model="delivery" value="true" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox label="SET COUNTRY" v-model="country" value="true" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox label="SET PIXEL ON SUBMIT" v-model="pixel_submit" value="true" hide-details></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small flat color="primary" :loading="loading" 
                v-clipboard:copy="getLink(r.slug)"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
              >copy link</v-btn>
              <v-btn small flat color="primary" :loading="loading" @click="edit(r)">edit</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'loading', 'staticPages'],
  data(){
    return {
      menu:{},
      selectedPrice:{},
      customer:false,
      lazy:false,
      language:false,
      delivery:false,
      country:false,
      pixel_submit:false,
    }
  },
  methods:{
    getLink(slug) {
      let pre = this.staticPages ? 'p' : 'lp'
      let Q = ''
      if(this.customer) {
        Q += `&name={NAME}&phone={PHONE}`
      }
      if(this.lazy) {
        Q += `&lazy=true`
      }
      if(this.language) {
        Q += `&language={LANGUAGE}`
      }
      if(this.delivery) {
        Q += `&delivery=DASHWXwD_wdWW`
      }
      if(this.country) {
        Q += `&cc={COUNTRY}`
      }
      if(this.pixel_submit) {
        Q += `&pixel_submit=true`
      }
      return `https://ashyaat.com/${pre}/${slug}${Q != '' ? '?': ''}${Q}`
    },
    edit(r) {
      this.$emit('editResource', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
    openURL(url){
      window.open(url, '_blank').blur();
      window.focus()
    }
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },

  }
}
</script>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.customCheckBoxCopyLink * {
  font-size: 11px;
}
</style>